import React from "react";
import { Wallet, House, Banknote, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

// ============================================================
// FYUNOR — Calculator Icon System
// A reusable, scalable icon mapping for every financial calculator.
// Clean outline icons only — consistent stroke weight (1.75),
// rounded corners, Fyunor blue accent. The single visual identity
// for each calculator across the entire site: cards, nav, switcher,
// related, header, search, and any future listing.
//
// To add a new calculator: add its id → icon pairing to ICON_MAP.
// ============================================================

const ICON_MAP = {
  "us-salary": Wallet,
  "us-mortgage": House,
  "us-loan": Banknote,
  "compound-interest": TrendingUp,
};

export function getCalculatorIcon(id) {
  return ICON_MAP[id] || null;
}

export default function CalculatorIcon({ id, className, size = 24, strokeWidth = 1.75 }) {
  const Icon = ICON_MAP[id];
  if (!Icon) return null;
  return (
    <Icon
      className={cn("shrink-0 text-primary", className)}
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden="true"
    />
  );
}